"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var CardMedia = /** @class */ (function (_super) {
    __extends(CardMedia, _super);
    function CardMedia() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardMedia.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, aspectRatio = _b.aspectRatio, style = _b.style, image = _b.image;
        var customProps = _1.omit(this.props, Object.keys(CardMedia.propTypes));
        var cardMediaClasses = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('card-media')] = true,
            _a[vdl_prefix_1.vdlPrefix('card-media--' + aspectRatio)] = true,
            _a);
        var bgStyle = Object.assign({}, style, {
            backgroundImage: typeof image === 'string' ? "url('" + image + "')" : undefined
        });
        return (React.createElement("div", __assign({}, customProps, { style: bgStyle, className: classnames_1.classNames(className, cardMediaClasses) }),
            React.createElement("div", { className: vdl_prefix_1.vdlPrefix('card-media__content') }, children)));
    };
    CardMedia.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        style: PropTypes.object,
        image: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element
        ]).isRequired,
        aspectRatio: PropTypes.oneOf([
            'wide',
            'square'
        ])
    };
    CardMedia.defaultProps = {
        aspectRatio: 'wide',
        image: ''
    };
    return CardMedia;
}(React.PureComponent));
exports.CardMedia = CardMedia;
